/**
 * Opens the Cookiebot consent dialog, if there is one to open.
 *
 * `window.Cookiebot` is not guaranteed to be the real SDK: cookie-dialog
 * blockers (Opera's built-in one, adblock filter lists) replace it with a
 * stub that has `consent` but no methods. Calling `Cookiebot?.renew()` on
 * such a stub throws "renew is not a function" from a click handler
 * (GlitchTip #134, on the consent gate in front of the job list). So: prefer
 * `renew()`, fall back to `show()`, otherwise do nothing.
 *
 * @returns {boolean} whether a dialog was requested
 */
export const openCookieSettings = () => {
  const cookiebot = typeof window === "undefined" ? undefined : window.Cookiebot
  if (typeof cookiebot?.renew === "function") {
    cookiebot.renew()
    return true
  }
  if (typeof cookiebot?.show === "function") {
    cookiebot.show()
    return true
  }
  return false
}
